import React from 'react';
import { Route, Redirect, IndexRoute } from 'react-router';
import DepartmentNews from './screens/DepartmentNews/router';
import CompanyNews from './screens/CompanyNews/router';
import CompanyRules from './screens/CompanyRules/router';
import InternalLinks from './screens/InternalLinks/router';
import LinksSetting from './screens/LinksSetting/router';
import StickyNotes from './screens/StickyNotes/router';
import Admin from './screens/CompanyAdmin/router';
import AssignmentTask from './screens/AssignmentTask/router';
import Order from './screens/Orders/router';
import AccountSetting from './screens/AccountSetting/router';
import PeopleSearch from './screens/PeopleSearch/router';
import Privacy from './screens/Privacy/router';
import EnsureLoggedIn from 'containers/App/components/EnsureLoggedIn/';
import Layout from 'containers/App/components/Layout/';
import LoginPass from './screens/LoginPass/router';
import Verification from './screens/Verification/router';
import PreferenceSettings from './screens/PreferenceSettings/router';

export default (
  <Route>
    {LoginPass}
    <Route path="mobile">
      {Privacy}
    </Route>
    <Route component={Layout}>
      {Privacy}
      {Verification}
      <Route component={EnsureLoggedIn}>
        <Route path="tube"
          getComponent={(location, cb) => {
            require.ensure([], (require) => {
              cb(null, require('./index'));
            });
          }}
        >
          <IndexRoute
            getComponent={(location, cb) => {
              require.ensure([], (require) => {
                cb(null, require('./screens/Index/'));
              });
            }}
          />
          {DepartmentNews}
          {CompanyNews}
          {CompanyRules}
          {InternalLinks}
          {LinksSetting}
          {StickyNotes}
          {AssignmentTask}
          {Admin}
          {Order}
          {AccountSetting}
          {PeopleSearch}
          {PreferenceSettings}
        </Route>
      </Route>
      <Redirect from="*" to="/tube" />
    </Route>
  </Route>
);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/router.js
 **/